import {
  SET_ADDRESSES,
  SET_BILLING_ADDRESSES,
  ADD_ADDRESS,
  DELETE_ADDRESS,
  EDIT_ADDRESS,
  HAVE_MAIN_ADDRESS,
  ADD_BILLING_ADDRESS,
  DELETE_BILLING_ADDRESS,
  EDIT_BILLING_ADDRESS,
} from '../types/AddressesTypes';

const initialState = {
  addresses: [],
  billingAdresses: [],
  haveMainAddress: false,
};

const addressesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ADDRESSES:
      return {
        ...state,
        addresses: action.addresses,
      };
    case SET_BILLING_ADDRESSES:
      return {
        ...state,
        billingAdresses: action.addresses,
      };
    case ADD_ADDRESS:
      return {
        ...state,
        addresses: [...state.addresses, action.address],
      };
    case ADD_BILLING_ADDRESS:
      return {
        ...state,
        billingAdresses: [...state.billingAdresses, action.address],
      };
    case DELETE_ADDRESS: {
      const updatedAddressesArray = state.addresses.filter(function (address) {
        return action.nickname !== address.nickName;
      });
      return {
        ...state,
        addresses: [...updatedAddressesArray],
      };
    }
    case DELETE_BILLING_ADDRESS: {
      const updatedAddressesArray = state.billingAdresses.filter(function (
        address,
      ) {
        return action.nickname !== address.nickName;
      });
      return {
        ...state,
        billingAdresses: [...updatedAddressesArray],
      };
    }
    case EDIT_ADDRESS: {
      const updatedAddressesArray = state.addresses.map((address) =>
        action.address.nickName === address.nickName
          ? {
              ...action.address,
              nickName: address.nickName,
              addressId: address.addressId,
              isMainCommerce: address.isMainCommerce,
            }
          : { ...address, primary: 'false' },
      );
      return {
        ...state,
        addresses: [...updatedAddressesArray],
      };
    }
    case EDIT_BILLING_ADDRESS: {
      const updatedAddressesArray = state.billingAdresses.map((address) =>
        action.address.nickName === address.nickName
          ? {
              ...action.address,
              nickName: address.nickName,
              addressId: address.addressId,
              isMainCommerce: address.isMainCommerce,
            }
          : address,
      );
      return {
        ...state,
        billingAdresses: [...updatedAddressesArray],
      };
    }
    case HAVE_MAIN_ADDRESS:
      return {
        ...state,
        haveMainAddress: action.have,
      };
    default:
      return state;
  }
};

export default addressesReducer;
